import {ReactElement} from "react";
import {LogInLogOutLoader} from "./LogInLogOutLoader";
import {ReactComponent as ExitFill} from "@zendeskgarden/svg-icons/src/16/exit-fill.svg";

export function LoggingOut(): ReactElement {
    return <LogInLogOutLoader text="Logging Out" image={<ExitFill height="32px" width="32px" />} />;
}